module.exports = __webpack_public_path__ + "56d820811b3ddaef0d834a3b235f029f.svg";